export default function _404() {
  return <h1>_404</h1>
}
